//import SelectCGWordArrPopup from "@/pages/comp/book_order/textbook/popup/select_cg_word_arr";
import SelectCGWordArrPopupArea from "@/pages/comp/book_order/textbook/common/popup/select_cg_word_arr";

function SelectCGWordArrPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    cg_word_arr: [],
    cg_word_pri_val_arr: [],
    select_cg_word_pri_val_arr: [],
    voice: "",
    ...props
  };

  return (
    <div>
      <SelectCGWordArrPopupArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        cg_word_arr={myProps.cg_word_arr}
        cg_word_pri_val_arr={myProps.cg_word_pri_val_arr}
        select_cg_word_pri_val_arr={myProps.select_cg_word_pri_val_arr}
        voice={myProps.voice}
      ></SelectCGWordArrPopupArea>
    </div>
  );
};
export default SelectCGWordArrPopup;